var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"fixed":"","show":_vm.show,"id":"sidebar"},on:{"update:show":function($event){_vm.show=$event}}},[_c('CSidebarBrand',{attrs:{"imgFull":{
      width: 170,
      alt: 'Logo',
      src: _vm.logoImage,
      class: 'logo-container',
    }}}),_c('CRenderFunction',{attrs:{"flat":"","content-to-render":_vm.nav}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }